import { render, staticRenderFns } from "./TownCross.vue?vue&type=template&id=19cada26&scoped=true"
import script from "./TownCross.vue?vue&type=script&lang=js"
export * from "./TownCross.vue?vue&type=script&lang=js"
import style0 from "./TownCross.vue?vue&type=style&index=0&id=19cada26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cada26",
  null
  
)

export default component.exports